import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";

export const freezedateAction = (data, cb) => async (dispatch) => {
  try {   
      const res = await axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/freezedate
      `, data, {
          headers: {
              "Authorization": localStorage.getItem("token"),
              },
      }).then((res) => {
        dispatch({ type: actionType.LOADER_FALSE })
        if (res && res.data.body) {
            
            toaster("success", res.data.message)
            
        } else {
            toaster("error", res.data.message)
        }
        if(cb){
          cb(res)
      }
    })
      
  } catch (err) {
      console.log(`err`, err)
  }
}

export const freezedateDeleteAction = (data, cb) => async (dispatch) => {
  const deleteDataId = data.id;
  try {
    const res = await axios.delete(
      `${apiConstants().PROPOSEL_API_URL}api/v1/freezedate/delete/${deleteDataId}`,
      {
        headers: {
          "Authorization": localStorage.getItem("token"),
        },
      }
    ).then((res) => {
      if (res && res.data.body == true) {
          toaster("success", res.data.message)
      } else {
          toaster("error", res.data.message)
      }
      if(cb){
        cb(res)
      }
    })
  } catch (err) {
    console.log(`err`, err);
  }
};




export const getAllFreezeData = (cb) => {
  return dispatch => {
    // Trigger a loading state
    dispatch({ type: actionType.LOADER_TRUE });
    
    // Make the API call
    axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/freezedate/get`, {
      headers: {
        "Authorization": localStorage.getItem("token"),
          
      }
    }).then((res) => {
      // Stop the loading state
      dispatch({ type: actionType.LOADER_FALSE });

      // Handle the response
      if (res.data.body) {
        dispatch({
          type: actionType.FREEZE_DATA,
          freezeData: res.data.body
        });
        
        // Callback function
        if (cb) {
          cb(res.data);
        }
        
        // Display a success message
        toaster("success", res.data.message);
      } else {
        // Display an error message
        toaster("error", res.data.message);
      }
    }).catch((error) => {
      // Stop the loading state
      dispatch({ type: actionType.LOADER_FALSE });

      // Display an error message
      toaster("error", "Failed to fetch data");
    });
  }
}

